// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B_7FoSWyIbYnV0dc1b29,
.B_7FoSWyIbYnV0dc1b29:focus,
.B_7FoSWyIbYnV0dc1b29:active,
.B_7FoSWyIbYnV0dc1b29:hover {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px !important;
  margin-left: 10px;
  background: #dacddb !important;
  border: none !important;
  border-radius: 8px !important;
}`, "",{"version":3,"sources":["webpack://./js/view/page/dataset-management/component/attachments/new-attachment/styles.scss"],"names":[],"mappings":"AAAA;;;;EAIE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,6BAAA;AACF","sourcesContent":[".add_button,\n.add_button:focus,\n.add_button:active,\n.add_button:hover {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px !important;\n  margin-left: 10px;\n  background: #dacddb !important;\n  border: none !important;\n  border-radius: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"add_button": `B_7FoSWyIbYnV0dc1b29`
};
export default ___CSS_LOADER_EXPORT___;
